import {
    SEND_MESSAGE_REQUEST,
    SEND_MESSAGE_SUCCESS,
    SEND_MESSAGE_FAIL,
    ADD_CHAT_MESSAGE,
    SET_CHAT_HISTORY,
    CLEAR_CHAT_HISTORY,
    SET_LOADING,
    CHAT_HISTORY_DATA
} from '../constants/amplitudeAITypes';

const initialState = {
    showLoad: false,
    loading: false,
    error: null,
    messages: [],
    history: []
};

const amplitudeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_MESSAGE_REQUEST:
            return {
                ...state,
                loading: true
            };

        case SEND_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                messages: [...state.messages, action.payload]
            };

        case SEND_MESSAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case ADD_CHAT_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, action.payload]
            };

        case SET_CHAT_HISTORY:
            return {
                ...state,
                messages: action.payload
            };

        case CLEAR_CHAT_HISTORY:
            return {
                ...state,
                messages: []
            };
        case SET_LOADING:
            return {
                ...state,
                showLoad: action.loading
            };
        case CHAT_HISTORY_DATA:
            return {
                ...state,
                history: action.history
            }
        default:
            return state;
    }
};

export default amplitudeReducer;